import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class ResendEmailConfirmationCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IResendEmailConfirmationCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'vehicleOwners/reSendEmailConfirmation/{ownerUserId}';

  public override setParameters(parameters: IResendEmailConfirmationCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{ownerUserId}',
      parameters.ownerId.toString()
    );
  }
}
export interface IResendEmailConfirmationCommandParameters
  extends ICommandParameters {
  ownerId: number;
}
